import React from 'react'
import { connect } from 'react-redux'
import {
  getRespondent,
  getLanguage,
  getInterest,
  getGMA,
} from 'ducks/respondent'
import { toQuiz, toGmaQuizWelcome } from 'ducks/router'
import * as R from 'ramda'

const InterestResults = ({ id: uuid, scores, language, status }) => {
  return <div>Interest Results</div>
}

export default connect(
  R.converge(R.mergeRight, [getInterest, getRespondent, getLanguage, getGMA]),
  dispatch => ({
    toQuiz: uuid => dispatch(toQuiz({ uuid })),
    toGma: uuid => dispatch(toGmaQuizWelcome({ uuid })),
  }),
)(InterestResults)
